<template>
<div class="row clearfix">
  <div v-if="loading">
    <BlockUI :message="blockuimsg"></BlockUI>
  </div>
  <div class="col-lg-12">
    <b-row>
        <b-col style="text-align:center">
          <h3>Recursos / Gráficos</h3>
        </b-col>
    </b-row>
    <div class="card">
      <div class="tab-content">
        <div class="table-responsive">
          <div class="d-flex justify-content-between align-items-center mb-4 pl-4">
            <b-pagination class="p-0 m-0"
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              aria-controls="my-table">
            </b-pagination>
            <div class="d-flex align-items-center pl-3 mr-auto">
              <label class="p-0 m-0 pr-3 text-purple">Filtrar por tags</label>
              <vue-tags-input
                v-model="taglist"
                :autocomplete-items="tagslist"
                :add-only-from-autocomplete="true"
                @tags-changed="updatelist"
              />
            </div>
            <div class="col-md-3">
              <ResourceSearchs :routeApi="'charts'" ref="searchcomponent"
                :perPage = "perPage"
                :newTags2 = "newTags2"
                @update="onUpdateDataResource"
                @loading="onLoading"
              />
          </div>
            <b-button @click="onNew" variant="success">
              + Añadir
            </b-button>
          </div>
          <b-table hover :items="resources"
          :fields="fields"
          :per-page="0"
          :current-page="currentPage"
          >
           <template v-slot:cell(actions)="row">
              <b-button class="btn btn-icon btn-icon-mini btn-round btn-info" @click="info(row.item, row.index, $event.target)">
                <i class="zmdi zmdi-edit"></i>
              </b-button>
              <b-button class="btn btn-icon btn-icon-mini btn-round btn-warning" @click="duplicate(row.item)">
                <i class="zmdi zmdi-copy"></i>
              </b-button>
              <b-button class="btn btn-icon btn-icon-mini btn-round btn-danger" @click="ondelete(row.item)">
                <i class="fa fa-trash"></i>
              </b-button>
          </template>
          </b-table>
        </div>
      </div>
    </div>
  </div>
  <!-- Info modal -->
    <b-modal :id="infoModal.id" :title="infoModal.title" hide-footer size="xl">
       <div class="modal-body">
        <b-row>
          <b-col md="6">
            <div>
              Nombre <b-form-input
                id="NOMBRE"
                v-model="selectedItem.NOMBRE"
                placeholder="Nombre..."
                :state="($v.selectedItem.NOMBRE.$dirty && submitted)?
                !$v.selectedItem.NOMBRE.$error : null"
                aria-describedby="nombre-feedback" />
                <b-form-invalid-feedback id="nombre-feedback">
                  Este campo es requerido.
                </b-form-invalid-feedback>
            </div>
            <div class="mt-2">
              Tipo <select class="form-control" v-model="selectedItem.TIPO_GRAFICO">
                <option value="0">Tablas de doble entrada</option>
                <option value="1">Coordenadas en cuadrícula</option>
                <option value="2">Gráfico de barras</option>
                <option value="3">Gráfico lineal</option>
                <option value="4">Pictograma</option>
                <option value="5">Gráfico circular</option>
                <option value="6">Eje cartesiano</option>
              </select>
               <b-form-input
                  id="TIPO_GRAFICO" v-model="selectedItem.TIPO_GRAFICO"
                  :state="($v.selectedItem.TIPO_GRAFICO.$dirty && submitted)?
                  !$v.selectedItem.TIPO_GRAFICO.$error : null"
                  aria-describedby="TIPO_GRAFICO-feedback" style="display: none"/>
                  <b-form-invalid-feedback id="TIPO_GRAFICO-feedback">
                    Este campo es requerido.
                  </b-form-invalid-feedback>
            </div>
            <div class="mt-2">
              Título del gráfico
              <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                <i class="zmdi zmdi-close-circle pointer pr-2 text-danger" v-if="selectedItem.TEXTOS_ID_TITULO_GRAFICO !== null && selectedItem.TEXTOS_ID_EST_INC3 !== 0"
                    @click="cleanSelection(0)"/>
                <input type="text" v-bind:value="getTranslation(selectedItem.TEXTOS_TITULO_GRAFICO)"
                disabled class="form-control" />
                <searchtexts class="pl-2" idModal="mdlSearchText_0"
                  v-on:selected="onSelectedText($event, 0)">
                </searchtexts>
              </div>
            </div>
            <div class="mt-2" v-if="parseInt(selectedItem.TIPO_GRAFICO)===0">
              Descripción <span class="font-italic"> (Para actividad tipo 4)</span>
              <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                <i class="zmdi zmdi-close-circle pointer pr-2 text-danger" v-if="selectedItem.TEXTOS_ID_DESCRIPCION !== null && selectedItem.TEXTOS_ID_DESCRIPCION !== 0"
                    @click="cleanSelection(3)"/>
                <input type="text" v-bind:value="getTranslation(selectedItem.TEXTOS_DESCRIPCION)"
                disabled class="form-control" />
                <searchtexts class="pl-2" idModal="mdlSearchText_3"
                  v-on:selected="onSelectedText($event, 3)">
                </searchtexts>
              </div>
            </div>
          </b-col>

          <b-col md="6">
            <b-row>
              <div class="col-md-4">
                Filas <b-form-input
                  id="FILAS" type="number"
                  v-model="selectedItem.FILAS"
                  :state="($v.selectedItem.FILAS.$dirty && submitted)?
                  !$v.selectedItem.FILAS.$error : null"
                  aria-describedby="filas-feedback" />
                  <b-form-invalid-feedback id="filas-feedback">
                    Este campo es requerido.
                  </b-form-invalid-feedback>
              </div>
              <div class="col-md-4">
                Columnas <b-form-input
                  id="COLUMNAS" type="number"
                  v-model="selectedItem.COLUMNAS"
                  :state="($v.selectedItem.COLUMNAS.$dirty && submitted)?
                  !$v.selectedItem.COLUMNAS.$error : null"
                  aria-describedby="columnas-feedback" />
                  <b-form-invalid-feedback id="columnas-feedback">
                    Este campo es requerido.
                  </b-form-invalid-feedback>
              </div>
            </b-row>
            <div class="mt-2">
              Título filas
              <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                <i class="zmdi zmdi-close-circle pointer pr-2 text-danger" v-if="selectedItem.TEXTOS_ID_TITULO_FILAS !== null && selectedItem.TEXTOS_ID_TITULO_FILAS !== 0"
                    @click="cleanSelection(1)"/>
                <input type="text" v-bind:value="getTranslation(selectedItem.TEXTOS_TITULO_FILAS)"
                disabled class="form-control" />
                <searchtexts class="pl-2" idModal="mdlSearchText_1"
                  v-on:selected="onSelectedText($event, 1)">
                </searchtexts>
              </div>
            </div>
            <div class="mt-2">
              Título columnas
              <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                <i class="zmdi zmdi-close-circle pointer pr-2 text-danger" v-if="selectedItem.TEXTOS_ID_TITULO_COLUMNAS !== null && selectedItem.TEXTOS_ID_TITULO_COLUMNAS !== 0"
                    @click="cleanSelection(2)"/>
                <input type="text" v-bind:value="getTranslation(selectedItem.TEXTOS_TITULO_COLUMNAS)"
                disabled class="form-control" />
                <searchtexts class="pl-2" idModal="mdlSearchText_2"
                  v-on:selected="onSelectedText($event, 2)">
                </searchtexts>
              </div>
            </div>
            <div class="mt-2" v-if="parseInt(selectedItem.TIPO_GRAFICO)===0">
              Imagen <span class="font-italic"> (Para actividad tipo 4)</span>
              <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                <i class="zmdi zmdi-close-circle pointer pr-2 text-danger" v-if="selectedItem.IMAGENES_ID !== null && selectedItem.IMAGENES_ID !== 0"
                    @click="cleanSelection(4)"/>
                <div class="image">
                    <img :src="getTranslation(selectedItem.IMAGENES_DESC)" alt="img"
                    style="width:110px;height:110px" class="img-fluid" v-if="selectedItem.IMAGENES_ID !== null && selectedItem.IMAGENES_ID !== 0">
                    <span class="font-italic" v-if="selectedItem.IMAGENES_ID === null || selectedItem.IMAGENES_ID === 0">Sin imagen</span>
                </div>
                <searchimages class="pl-2" idModal="mdlSearchImageDesc"
                  v-on:selected="onSelectedImageDesc($event)">
                </searchimages>
              </div>
            </div>
          </b-col>
        </b-row>

        <hr>

       <b-row>
        <b-col  style="text-align:center">
          <strong>Operaciones del ejercicio</strong>
          <b-button @click="addArrayEleOperation()" class="btn btn-primary ml-2" size="sm">+</b-button>
        </b-col>
      </b-row>

        <div v-for="(operation, index) in arrayEleOperation" v-bind:key="index">
            <br/>
            <b-row>
              <div class="pr-3 mt-3">
                <b-button v-if="arrayEleOperation.length > 1" @click="removeArrayEleOperation(index)" class="btn btn-danger ml-2" size="sm">-</b-button>
              </div>
              <div class="col-sm3">
                Tipo de elemento <select class="form-control" v-model="arrayEleOperation[index].TIPO_ELEMENTO">
                  <option value="0">Cabecera de fila</option>
                  <option value="1">Cabecera de columna</option>
                  <option value="2">Celda</option>
                  <option value="3">Pictograma</option>
                </select>
                 <div>
                  <b-form-input
                      v-bind:id="'TIPO_ELEMENTO' + index"
                      v-model="arrayEleOperation[index].TIPO_ELEMENTO"
                      :state="($v.arrayEleOperation.$each[index].TIPO_ELEMENTO.$dirty && submitted)?
                      !$v.arrayEleOperation.$each[index].TIPO_ELEMENTO.$error : null"
                      v-bind:aria-describedby="'TIPO_ELEMENTO-feedback' + index" style="display: none"/>
                  <b-form-invalid-feedback v-bind:id="'TIPO_ELEMENTO-feedback' + index">
                    Este campo es requerido.
                  </b-form-invalid-feedback>
                </div>
              </div>
              <div class="col">
                Pos. Fila <b-form-input style="width:70%"
                  id="FILAS" type="number"
                  v-model="arrayEleOperation[index].POSICION_FILA" />
                  <div>
                  <b-form-input
                      v-bind:id="'POSICION_FILA' + index"
                      v-model="arrayEleOperation[index].POSICION_FILA"
                      :state="($v.arrayEleOperation.$each[index].POSICION_FILA.$dirty && submitted)?
                      !$v.arrayEleOperation.$each[index].POSICION_FILA.$error : null"
                      v-bind:aria-describedby="'POSICION_FILA-feedback' + index" style="display: none"/>
                  <b-form-invalid-feedback v-bind:id="'POSICION_FILA-feedback' + index">
                    Este campo es requerido.
                  </b-form-invalid-feedback>
                </div>
              </div>
              <div class="col">
                Pos. Columna <b-form-input style="width:70%"
                  id="FILAS" type="number"
                  v-model="arrayEleOperation[index].POSICION_COLUMNA" />
                  <b-form-input
                      v-bind:id="'POSICION_COLUMNA' + index"
                      v-model="arrayEleOperation[index].POSICION_COLUMNA"
                      :state="($v.arrayEleOperation.$each[index].POSICION_COLUMNA.$dirty && submitted)?
                      !$v.arrayEleOperation.$each[index].POSICION_COLUMNA.$error : null"
                      v-bind:aria-describedby="'POSICION_COLUMNA-feedback' + index" style="display: none"/>
                  <b-form-invalid-feedback v-bind:id="'POSICION_COLUMNA-feedback' + index">
                    Este campo es requerido.
                  </b-form-invalid-feedback>
              </div>
              <div class="col" v-if="parseInt(arrayEleOperation[index].TIPO_ELEMENTO)===2">
                Valor
                <small class="text-secondary" v-if="parseInt(selectedItem.TIPO_GRAFICO)===0">(hidden)</small>
                <b-form-input
                  id="VALOR" type="text"
                  v-model="arrayEleOperation[index].VALOR" />
                  <b-form-input
                      v-bind:id="'VALOR' + index"
                      v-model="arrayEleOperation[index].VALOR"
                      :state="($v.arrayEleOperation.$each[index].VALOR.$dirty && submitted)?
                      !$v.arrayEleOperation.$each[index].VALOR.$error : null"
                      v-bind:aria-describedby="'VALOR-feedback' + index" style="display: none"/>
                  <b-form-invalid-feedback v-bind:id="'VALOR-feedback' + index">
                    Este campo es requerido.
                  </b-form-invalid-feedback>
              </div>
              <div class="col" v-if="parseInt(selectedItem.TIPO_GRAFICO)===0">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input"
                    v-model="arrayEleOperation[index].INCOGNITA"
                    v-bind:id="'INCOGNITA'+index">
                  <label class="custom-control-label" v-bind:for="'INCOGNITA'+index">Incognita</label>
                </div>
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input"
                    v-model="arrayEleOperation[index].VISIBLE"
                    v-bind:id="'VISIBLE'+index">
                  <label class="custom-control-label" v-bind:for="'VISIBLE'+index">Visible</label>
                </div>
              </div>
              <div class="col" v-if="parseInt(selectedItem.TIPO_GRAFICO)===0">
                Orden Pregunta
                <b-form-input style="width:70%"
                  v-bind:id="'ORDEN'+index" type="number"
                  v-model="arrayEleOperation[index].ORDEN" />
              </div>
            </b-row>
            <br/>
            <b-row>
              <b-col md="4">
                <div>
                  Texto
                  <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                    <i class="zmdi zmdi-close-circle pointer pr-2 text-danger" v-if="arrayEleOperation[index].TEXTOS_ID !== null"
                    @click="cleanSelectionArrayElement(index,0)"/>
                    <input type="text" v-bind:value="getTranslation(arrayEleOperation[index].TEXTOS)"
                      disabled class="form-control" />
                    <searchtexts class="pl-2" :idModal="'mdlSearchText_multi_' + index"
                      v-on:selected="onSelectedText($event, index, true)">
                    </searchtexts>
                  </div>
                </div>
              </b-col>
              <b-col md="4">
                <div>
                 Imagen
                  <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                    <i class="zmdi zmdi-close-circle pointer pr-2 text-danger" v-if="arrayEleOperation[index].IMAGENES_ID !== null && arrayEleOperation[index].IMAGENES_ID !== 0"
                    @click="cleanSelectionArrayElement(index,1)"/>
                    <div class="image">
                        <img :src="getTranslation(arrayEleOperation[index].IMAGENES)" alt="img"
                        style="width:110px;height:110px" class="img-fluid" v-if="arrayEleOperation[index].IMAGENES_ID !== null && arrayEleOperation[index].IMAGENES_ID !== 0">
                        <span class="font-italic" v-if="arrayEleOperation[index].IMAGENES_ID === null || arrayEleOperation[index].IMAGENES_ID === 0">Sin imagen</span>
                    </div>
                    <searchimages class="pl-2" :idModal="'mdlSearchImage_multi_' + index"
                      v-on:selected="onSelectedImage($event, index)">
                    </searchimages>
                  </div>
                </div>
              </b-col>
              <b-col md="4">
                <div>
                  Audio
                  <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                     <i class="zmdi zmdi-close-circle pointer pr-2 text-danger" v-if="arrayEleOperation[index].AUDIOS_ID !== null && arrayEleOperation[index].AUDIOS_ID !== 0"
                    @click="cleanSelectionArrayElement(index,2)"/>
                     <audio :src="getTranslation(arrayEleOperation[index].AUDIOS)" controls="controls"
                              style="width:100%" type="audio/mpeg" preload="preload" v-if="arrayEleOperation[index].AUDIOS_ID !== null && arrayEleOperation[index].AUDIOS_ID !== 0">
                    </audio>
                    <span class="font-italic" v-if="arrayEleOperation[index].AUDIOS_ID === null || arrayEleOperation[index].AUDIOS_ID === 0">Sin audio</span>
                    <searchaudios class="pl-2" :idModal="'mdlSearchAudio_multi_' + index"
                      v-on:selected="onSelectedAudio($event, index)">
                    </searchaudios>
                  </div>
                </div>
              </b-col>
            </b-row>
            <hr/>
        </div>

        <label for="Tag">
        <br>
        Etiquetas</label>
          <div>
          <vue-tags-input
            v-model="tag"
            :tags="tags"
            :autocomplete-items="autocompleteItems"
            @tags-changed="update"
          />
        </div>
        <div class="modal-footer">
          <button type="button" @click="save"
          class="btn btn-info btn-round waves-effect">
            Guardar</button>
          <b-button class="btn btn-default btn-round waves-effect" block
          @click="$bvModal.hide('info-modal')">Cerrar</b-button>
        </div>
      </div>
    </b-modal>
</div>

</template>

<script>
import VueTagsInput from '@johmun/vue-tags-input';
import { required } from 'vuelidate/lib/validators';
import searchimages from '../images/SearchImages.vue';
import searchtexts from '../texts/SearchTexts.vue';
import searchaudios from '../audios/SearchAudios.vue';
import ResourceSearchs from '../../../components/panel/ResourceSearchs.vue';
import searchMixin from '../../../mixins/search';
import translationMixin from '../../../mixins/translation';

export default {
  components: {
    VueTagsInput,
    searchimages,
    searchtexts,
    searchaudios,
    ResourceSearchs,
  },
  name: 'gridCharts',
  mixins: [searchMixin, translationMixin],
  data() {
    return {
      perPage: 20,
      rows: 0,
      submitted: false,
      currentPage: 1,
      arrayEleOperation: [],
      selectedNumElements: 1,
      nshapes: [
        { value: 1 },
        { value: 2 },
        { value: 3 },
        { value: 4 },
        { value: 5 },
        { value: 6 },
        { value: 7 },
        { value: 8 },
        { value: 9 },
        { value: 10 },
        { value: 11 },
        { value: 12 },
        { value: 13 },
        { value: 14 },
        { value: 15 },
        { value: 16 },
        { value: 17 },
        { value: 18 },
        { value: 19 },
        { value: 20 },
      ],
      fields: [
        { key: 'NOMBRE', label: 'Nombre' },
        { key: 'TIPO_GRAFICO_DESC', label: 'Tipo' },
        { key: 'FILAS', label: 'Filas' },
        { key: 'COLUMNAS', label: 'Columnas' },
        { key: 'actions', label: 'Acciones', tdClass: 'tdActionClass' },
      ],
      resources: [],
      selectedItem: {
        ID: null,
        NOMBRE: null,
        TIPO_GRAFICO: null,
        FILAS: null,
        COLUMNAS: null,
        TEXTOS_ID_TITULO_GRAFICO: null,
        TEXTOS_ID_TITULO_FILAS: null,
        TEXTOS_ID_TITULO_COLUMNAS: null,
        TEXTOS_ID_DESCRIPCION: null,
        IMAGENES_ID: null,
        // Text to show on forms
        TEXTOS_TITULO_GRAFICO: [],
        TEXTOS_TITULO_FILAS: [],
        TEXTOS_TITULO_COLUMNAS: [],
        TEXTOS_DESCRIPCION: [],
        IMAGENES_DESC: [],
      },
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      tag: '',
      taglist: '',
      tags: [],
      newTags: [],
      newTags2: [],
      tagslist: [],
      autocompleteItems: [],
    };
  },
  validations: {
    selectedItem: {
      NOMBRE: {
        required,
      },
      TIPO_GRAFICO: {
        required,
      },
      FILAS: {
        required,
      },
      COLUMNAS: {
        required,
      },
    },
    arrayEleOperation: {
      $each: {
        TIPO_ELEMENTO: {
          required,
        },
        POSICION_FILA: {
          required,
        },
        POSICION_COLUMNA: {
          required,
        },
        VALOR: {
          required,
        },
      },
    },
  },
  methods: {
    removeArrayEleOperation(index) {
      this.arrayEleOperation.splice(index, 1);
    },
    addArrayEleOperation() {
      this.arrayEleOperation.push({
        TIPO_ELEMENTO: '0',
        POSICION_FILA: '0',
        POSICION_COLUMNA: '0',
        VALOR: null,
        INCOGNITA: 0,
        VISIBLE: 0,
        ORDEN: 1,
        TEXTOS_ID: null,
        TEXTOS: [],
        IMAGENES_ID: null,
        IMAGENES: [],
        AUDIOS_ID: null,
        AUDIOS: [],
        TRATAMIENTOINF_GRAF_ID: null,
      });
    },
    cleanSelectionArrayElement(pos, type) {
      switch (type) {
        case 0:
          this.arrayEleOperation[pos].TEXTOS_ID = null;
          this.arrayEleOperation[pos].TEXTOS = [];
          break;
        case 1:
          this.arrayEleOperation[pos].IMAGENES_ID = null;
          this.arrayEleOperation[pos].IMAGENES = [];
          break;
        case 2:
          this.arrayEleOperation[pos].AUDIOS_ID = null;
          this.arrayEleOperation[pos].AUDIOS = [];
          break;
        default:
          break;
      }
    },
    cleanSelection(type) {
      switch (type) {
        case 0:
          this.selectedItem.TEXTOS_ID_TITULO_GRAFICO = null;
          this.selectedItem.TEXTOS_TITULO_GRAFICO = [];
          break;
        case 1:
          this.selectedItem.TEXTOS_ID_TITULO_FILAS = null;
          this.selectedItem.TEXTOS_TITULO_FILAS = [];
          break;
        case 2:
          this.selectedItem.TEXTOS_ID_TITULO_COLUMNAS = null;
          this.selectedItem.TEXTOS_TITULO_COLUMNAS = [];
          break;
        case 3:
          this.selectedItem.TEXTOS_ID_DESCRIPCION = null;
          this.selectedItem.TEXTOS_DESCRIPCION = [];
          break;
        case 4:
          this.selectedItem.IMAGENES_ID = null;
          this.selectedItem.IMAGENES_DESC = [];
          break;
        default:
          break;
      }
    },
    /**
    * @method onSelectedText
    * @description Al seleccionar un texto
    */
    onSelectedText(itemSelected, type, isMulti = false) {
      if (isMulti) {
        this.arrayEleOperation[type].TEXTOS_ID = itemSelected.ID;
        this.arrayEleOperation[type].TEXTOS = [];
        this.setTranslation('TEXTO_', itemSelected, this.arrayEleOperation[type].TEXTOS);
        this.$root.$emit('bv::hide::modal', `mdlSearchText_multi_${type}`);
      } else {
        switch (type) {
          case 0:
            this.selectedItem.TEXTOS_ID_TITULO_GRAFICO = itemSelected.ID;
            this.selectedItem.TEXTOS_TITULO_GRAFICO = [];
            this.setTranslation('TEXTO_', itemSelected, this.selectedItem.TEXTOS_TITULO_GRAFICO);
            break;
          case 1:
            this.selectedItem.TEXTOS_ID_TITULO_FILAS = itemSelected.ID;
            this.selectedItem.TEXTOS_TITULO_FILAS = [];
            this.setTranslation('TEXTO_', itemSelected, this.selectedItem.TEXTOS_TITULO_FILAS);
            break;
          case 2:
            this.selectedItem.TEXTOS_ID_TITULO_COLUMNAS = itemSelected.ID;
            this.selectedItem.TEXTOS_TITULO_COLUMNAS = [];
            this.setTranslation('TEXTO_', itemSelected, this.selectedItem.TEXTOS_TITULO_COLUMNAS);
            break;
          case 3:
            this.selectedItem.TEXTOS_ID_DESCRIPCION = itemSelected.ID;
            this.selectedItem.TEXTOS_DESCRIPCION = [];
            this.setTranslation('TEXTO_', itemSelected, this.selectedItem.TEXTOS_DESCRIPCION);
            break;
          default:
            break;
        }

        this.$root.$emit('bv::hide::modal', `mdlSearchText_${type}`);
      }
    },
    /**
    * @method onSelectedImage
    * @description Al seleccionar una imagen
    */
    onSelectedImage(itemSelected, index) {
      debugger;
      this.arrayEleOperation[index].IMAGENES_ID = itemSelected.ID;
      this.arrayEleOperation[index].IMAGENES = [];
      this.arrayEleOperation[index].IMAGENES = itemSelected.FICHERO;
      this.$root.$emit('bv::hide::modal', `mdlSearchImage_multi_${index}`);
    },
    onSelectedImageDesc(itemSelected) {
      this.selectedItem.IMAGENES_ID = itemSelected.ID;
      this.selectedItem.IMAGENES_DESC = [];
      this.selectedItem.IMAGENES_DESC = itemSelected.FICHERO;
      this.$root.$emit('bv::hide::modal', 'mdlSearchImageDesc');
    },
    /**
    * @method onSelectedAudio
    * @description Al seleccionar una audio
    */
    onSelectedAudio(itemSelected, type) {
      this.arrayEleOperation[type].AUDIOS_ID = itemSelected.ID;
      this.arrayEleOperation[type].AUDIOS = [];
      this.arrayEleOperation[type].AUDIOS = itemSelected.FICHERO;
      this.setTranslation('FICHERO_', itemSelected, this.arrayEleOperation[type].AUDIOS);
      this.$root.$emit('bv::hide::modal', `mdlSearchAudio_multi_${type}`);
    },
    onNew() {
      this.submitted = false;
      this.limpiar();
      this.infoModal.title = 'Nuevo Gráfico';
      this.$root.$emit('bv::show::modal', this.infoModal.id);
    },
    limpiar() {
      this.selectedNumElements = 1;
      this.arrayEleOperation = [];
      this.selectedItem.ID = null;
      this.selectedItem.NOMBRE = null;
      this.selectedItem.TIPO_GRAFICO = null;
      this.selectedItem.FILAS = null;
      this.selectedItem.COLUMNAS = null;
      this.selectedItem.TEXTOS_ID_TITULO_GRAFICO = null;
      this.selectedItem.TEXTOS_ID_TITULO_FILAS = null;
      this.selectedItem.TEXTOS_ID_TITULO_COLUMNAS = null;
      this.selectedItem.TEXTOS_ID_DESCRIPCION = null;
      this.selectedItem.TEXTOS_TITULO_GRAFICO = [];
      this.selectedItem.TEXTOS_TITULO_FILAS = [];
      this.selectedItem.TEXTOS_TITULO_COLUMNAS = [];
      this.selectedItem.TEXTOS_DESCRIPCION = [];
      this.selectedItem.IMAGENES_DESC = [];
      this.tag = '';
      this.tags = [];
    },
    async ondelete(item) {
      const confirmation = await this.$bvModal.msgBoxConfirm('Esta a punto de eliminar un registro ¿Esta seguro?');
      if (confirmation) {
        /** Elimino los tags asociados */
        const url = `Tagscharts/deleteTags/${item.ID}`;
        this.axios.get(url);

        this.loading = true;
        const response = await this.axios.post('charts/delete', { ID: item.ID });
        if (response.data.status === 'success') {
          this.loading = false;
          this.$toasted.show('Se elimino el registro seleccionado.', { theme: 'outline', type: 'success', duration: 5000 });
          this.getPostData();
        } else {
          this.loading = false;
          this.$toasted.show(response.data.message, { theme: 'outline', type: 'error', duration: 5000 });
        }
      }
    },
    async duplicate(item) {
      try {
        const confirmation = await this.$bvModal.msgBoxConfirm('¿Deseas duplicar el gráfico seleccionado?');
        if (confirmation) {
          this.loading = true;
          const response = await this.axios.post(`charts/duplicate/${item.ID}`);
          this.loading = false;
          this.$toasted.show(response.data.message, { type: response.data.status });
          await this.getPostData();
        }
      } catch (e) {
        this.loading = false;
        this.$toasted.show('Ocurrió un error al duplicar', { type: 'warning' });
      }

      this.loading = false;
    },
    async info(item, index, button) {
      this.limpiar();
      this.submitted = false;
      this.infoModal.title = 'Editar Gráfico';
      this.loading = true;
      try {
        const response = await this.axios.get('charts/getchart', {
          params: {
            id: item.ID,
          },
        });
        this.selectedItem = response.data.content;
        this.selectedNumElements = response.data.elements.length;
        response.data.elements.forEach((element) => {
          this.arrayEleOperation.push({
            TIPO_ELEMENTO: element.TIPO_ELEMENTO,
            POSICION_FILA: element.POSICION_FILA,
            POSICION_COLUMNA: element.POSICION_COLUMNA,
            VALOR: element.VALOR,
            INCOGNITA: element.INCOGNITA,
            VISIBLE: element.VISIBLE,
            ORDEN: element.ORDEN,
            TEXTOS_ID: element.TEXTOS_ID,
            TEXTOS: element.TEXTOS,
            IMAGENES_ID: element.IMAGENES_ID,
            IMAGENES: element.IMAGENES,
            AUDIOS_ID: element.AUDIOS_ID,
            AUDIOS: element.AUDIOS,
          });
        });
      } catch (e) {
        this.$toasted.show('Ocurrió un error al leer el gráfico', { type: 'warning' });
      }

      this.getExistingTags(item.ID);
      this.$root.$emit('bv::show::modal', this.infoModal.id, button);
    },
    async save() {
      this.submitted = true;
      this.$v.selectedItem.$touch();
      this.$v.arrayEleOperation.$touch();
      const NUM_ELEMENTOS = parseInt(this.arrayEleOperation.length, 10);
      let errorarrayelement = false;
      for (let i = 0; i < NUM_ELEMENTOS; i += 1) {
        if (this.$v.arrayEleOperation.$each.$iter[i].$anyError) {
          errorarrayelement = true;
          break;
        }
      }
      if (this.$v.selectedItem.$anyError || errorarrayelement) {
        return;
      }
      this.loading = true;
      const elemntsoperation = [];
      this.arrayEleOperation.forEach((element) => {
        elemntsoperation.push({
          // ID: element.ID,
          TIPO_ELEMENTO: element.TIPO_ELEMENTO,
          POSICION_FILA: element.POSICION_FILA,
          POSICION_COLUMNA: element.POSICION_COLUMNA,
          VALOR: element.VALOR,
          INCOGNITA: element.INCOGNITA,
          VISIBLE: element.VISIBLE,
          ORDEN: element.ORDEN,
          TEXTOS_ID: element.TEXTOS_ID,
          AUDIOS_ID: element.AUDIOS_ID,
          IMAGENES_ID: element.IMAGENES_ID,
          TRATAMIENTOINF_GRAF_ID: -1,
        });
      });
      const templateData = {
        ID: this.selectedItem.ID || -1,
        NOMBRE: this.selectedItem.NOMBRE,
        TIPO_GRAFICO: this.selectedItem.TIPO_GRAFICO,
        FILAS: this.selectedItem.FILAS,
        COLUMNAS: this.selectedItem.COLUMNAS,
        TEXTOS_ID_TITULO_GRAFICO: this.selectedItem.TEXTOS_ID_TITULO_GRAFICO,
        TEXTOS_ID_TITULO_FILAS: this.selectedItem.TEXTOS_ID_TITULO_FILAS,
        TEXTOS_ID_TITULO_COLUMNAS: this.selectedItem.TEXTOS_ID_TITULO_COLUMNAS,
        TEXTOS_ID_DESCRIPCION: this.selectedItem.TEXTOS_ID_DESCRIPCION,
        IMAGENES_ID: this.selectedItem.IMAGENES_ID,
        ELEMENTOS: elemntsoperation,
      };
      try {
        const response = await this.axios.post('charts/store', templateData);
        if (response.data.status === 'success') {
          // Solo si esta creando agrego el evento
          if (this.selectedItem.ID === -1 || this.selectedItem.ID === null) {
            const bc = new BroadcastChannel('new_resource_chart');
            bc.postMessage({
              ID: response.data.id,
              NOMBRE: this.selectedItem.NOMBRE,
              TIPO_GRAFICO: this.selectedItem.TIPO_GRAFICO,
              FILAS: this.selectedItem.FILAS,
              COLUMNAS: this.selectedItem.COLUMNAS,
              TEXTOS_ID_TITULO_GRAFICO: this.selectedItem.TEXTOS_ID_TITULO_GRAFICO,
              TEXTOS_ID_TITULO_FILAS: this.selectedItem.TEXTOS_ID_TITULO_FILAS,
              TEXTOS_ID_TITULO_COLUMNAS: this.selectedItem.TEXTOS_ID_TITULO_COLUMNAS,
              TEXTOS_ID_DESCRIPCION: this.selectedItem.TEXTOS_ID_DESCRIPCION,
              IMAGENES_ID: this.selectedItem.IMAGENES_ID,
            });
          }

          const url = `Tagscharts/deleteTags/${response.data.id}`;
          const url2 = 'Tagscharts/saveTag';

          this.axios.get(url);
          this.newTags.forEach((a) => {
            this.axios.get(`Tags/findTagByName/${a.text}`,
              { name: a.text }).then((resp) => {
              if (resp.data.status === 'success') {
                this.axios.post(url2, { id: resp.data.id, idtexto: response.data.id });
              } else {
                this.axios.post(url2, { id: a.key, idtexto: response.data.id });
              }
            });
          });

          this.$toasted.show('Los datos se guardaron satisfactoriamente.', { theme: 'outline', type: 'success', duration: 5000 });
          this.$root.$emit('bv::hide::modal', this.infoModal.id);
          this.limpiar();

          // Auto close if coming from a create event
          if (this.bAutoClose) {
            window.open('', '_self').close();
          }

          await this.getPostData();
        } else {
          this.$toasted.show(response.data.message, { theme: 'outline', type: 'error', duration: 5000 });
        }
        this.loading = false;
      } catch (e) {
        const resp = e;
        if (!resp.body.Ok) {
          this.$toasted.show(resp.body.Message, { theme: 'outline', type: 'error', duration: 5000 });
        }
        this.loading = false;
      }
    },
    async getCharts() {
      this.loading = true;

      try {
        const response = await this.axios.get('charts');
        this.resources = response.data;
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    async getPostData() {
      this.loading = true;
      try {
        const response = await this.axios.get('charts', {
          params: {
            currentPage: this.currentPage,
            size: this.perPage,
            newTags: this.newTags2,
            resourcetosearch: this.$refs.searchcomponent.resoursetosearch,
          },
        });
        this.rows = response.data.rows;
        this.resources = Object.keys(response.data.results).map(k => response.data.results[k]);
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    updatelist(newTags) {
      this.newTags2 = newTags;
      this.getPostData();
    },
    listTags() {
      const url = 'Tags';
      const datos = [];
      this.axios.get(url).then((res) => {
        res.data.forEach((a) => {
          datos.push({ key: a.ID, text: a.NOMBRE });
        });
        this.tagslist = datos;
      })
        .catch((error) => {
          console.error(error);
        });
      this.loading = false;
    },
    initItems() {
      const url = 'Tags';
      const datos = [];

      this.axios.get(url).then((res) => {
        res.data.forEach((a) => {
          datos.push({ text: a.NOMBRE, key: a.ID });
        });
        this.autocompleteItems = datos;
      })
        .catch((error) => {
          console.error(error);
        });
      this.loading = false;
    },
    update(newTags) {
      this.tags = newTags;
      this.newTags = newTags;
    },
    async getExistingTags(idtxt) {
      const url = `Tagscharts/findByChart/${idtxt}`;
      const datos = [];
      this.loading = true;

      try {
        this.axios.get(url).then((res) => {
          res.data.forEach((a) => {
            datos.push({ text: a.NOMBRE, key: a.ID });
          });
          this.tags = datos;
        })
          .catch((error) => {
            console.error(error);
          });
        this.loading = false;
      } catch (e) {
        console.log(e);
        this.loading = false;
      }
    },
  },
  async mounted() {
    await this.getPostData();
    this.initItems();
    this.listTags();

    // Open create modal automatically
    const self = this;
    const bc = new BroadcastChannel('new_resource_chart_open');
    bc.onmessage = () => {
      self.bAutoClose = true;
      self.onNew();
    };

    if (this.$route.params.id != null) {
      const item = {
        ID: this.$route.params.id,
      };
      this.info(item, null, null);
    }
  },
  watch: {
    currentPage: {
      handler() {
        this.getPostData().catch((error) => {
          console.error(error);
        });
      },
    },
  },
};
</script>
<style>
  .tdActionClass{
    width: 180px;
    text-align: center
  }
</style>
